import {css} from '@emotion/react';
import {ClickAwayListener, useTheme} from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import {DlMuiDynamicIcon, DlMuiTypography, getIconComponentByName, GetStylesFunction, TranslateUtils} from '@wallaby-ui/core';
import React from 'react';
import {defineMessages, useIntl} from 'react-intl';
import {NavLink} from 'react-router-dom';

import {NavigationContext} from '../useNavigationContext';
import classNames from 'classnames';

const I18N = defineMessages({
  LOGOUT_BUTTON: {
    id: 'login.button.logout',
    defaultMessage: 'Logout',
    description: 'text for logout button',
  },
  USER_SETTINGS: {
    id: 'login.userSettings',
    defaultMessage: 'User settings',
    description: 'text for user settings link',
  },
});

interface OwnProps {
  navigationContext: NavigationContext;
  handleLogout: () => void;
  isNavigationOpen: boolean;
}

type Props = OwnProps;

export const UserSectionMenu: React.FC<Props> = (props) => {
  const {navigationContext, handleLogout, isNavigationOpen} = props;
  const {isUserMenuOpen, setUserMenuOpen} = navigationContext;
  const theme = useTheme();
  const intl = useIntl();

  const styles = getStyles({theme});
  const userMenuOnClose = () => setUserMenuOpen(false);
  return (
    <>
      {isUserMenuOpen ? (
        <ClickAwayListener onClickAway={userMenuOnClose}>
          <div
            css={styles.menu}
            className={classNames({
              navigationOpen: !isNavigationOpen,
            })}
          >
            <NavLink
              tabIndex={0}
              // title={TranslateUtils.translate(I18N.USER_SETTINGS, intl)}
              to={'/settings'}
              css={styles.menuRow}
              onClick={userMenuOnClose}
              onKeyPress={userMenuOnClose}
            >
              <SvgIcon component={getIconComponentByName('settingsIconMultiColor') as any} inheritViewBox css={styles.icon} />
              <DlMuiTypography
                variant={'loginMenu'}
                inputCss={styles.label}
                value={TranslateUtils.translate(I18N.USER_SETTINGS, intl)}
                // title={TranslateUtils.translate(I18N.USER_SETTINGS, intl)}
              />
            </NavLink>
            <div css={styles.menuRow} tabIndex={0} onClick={handleLogout} onKeyPress={handleLogout}>
              <SvgIcon component={getIconComponentByName('logoutIconMultiColor') as any} inheritViewBox css={styles.icon} />
              <DlMuiTypography
                inputCss={styles.label}
                variant={'loginMenu'}
                // title={TranslateUtils.translate(I18N.LOGOUT_BUTTON, intl)}
                value={TranslateUtils.translate(I18N.LOGOUT_BUTTON, intl)}
              />
            </div>
          </div>
        </ClickAwayListener>
      ) : null}
    </>
  );
};

UserSectionMenu.displayName = 'UserSectionMenu';

const getStyles: GetStylesFunction = (options) => ({
  menu: css`
    position: absolute;
    z-index: 1000;
    left: 176px;
    top: 107px;
    transform: translate(-100%, 0);
    padding: 0;
    background-color: ${options?.theme?.palette.custom.userMenu as string};
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    &.navigationOpen {
      border: 1px solid ${options?.theme?.palette.custom.userMenuBorder as string};
    }
  `,
  menuRow: css({
    'height': 40,
    'paddingInline': 16,
    'display': 'flex',
    'flexDirection': 'row',
    'gap': 16,
    'justifyContent': 'flex-start',
    'alignItems': 'center',
    'textDecoration': 'none',
    'cursor': 'pointer',
    'userSelect': 'none',
    'textOverflow': 'ellipsis',
    'whiteSpace': 'nowrap',
    'overflow': 'hidden',

    'backgroundColor': `${options?.theme?.palette.custom.userMenuRow}`,
    '&:hover, &:focus': {
      backgroundColor: `${options?.theme?.palette.custom.userMenuRowHover}`,
      outline: 'none',
      textDecoration: 'none',
    },
    '&:active': {
      backgroundColor: `${options?.theme?.palette.custom.userMenuRowPressed}`,
      outline: 'none',
      textDecoration: 'none',
    },
  }),
  icon: css({
    width: '16px',
    height: '16px',
    color: `${options?.theme?.palette.custom.userMenuIcon}`,
  }),
  label: css({}),
});
